module.exports = __webpack_public_path__ + "img/action-blur.3b55f2fb.svg";